import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const semaphore = defineConnector({
  identifier: "semaphore",
  name: "Semaphore",
  tagLine: "Continuous integration and delivery",
  logo,
  protocol: "http",
  tags: ["engineering"],
  defaultUrlPattern: ({ host }) =>
    host
      ? `https://${host.replace(/\./g, "\\.")}/.*`
      : "https://[^/]*\\.semaphoreci\\.com/.*",
  auth: (app) =>
    headerAuth([
      {
        name: "Authorization",
        value: app.secret.apiToken,
        scheme: "Token",
      },
      { name: "User-Agent", value: "SemaphoreCI v2.0 Client" },
    ]),
  steps: [
    {
      title: "Get your API token",
      items: [
        {
          kind: "markdown",
          content:
            "Find your API token in your [Semaphore account settings](https://me.semaphoreci.com/account).",
        },
      ],
    },
    {
      title: "Enter your organization URL and API token",
      items: [
        {
          kind: "hostname",
          label: "Organization URL",
          required: true,
          placeholder: "yourorg.semaphoreci.com",
          target: { kind: "configuration", field: "host" },
          helperText:
            "Your Semaphore organization URL (e.g., yourorg.semaphoreci.com)",
        },
        {
          kind: "input",
          label: "API token",
          required: true,
          target: { kind: "secrets", field: "apiToken" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ host }) =>
      `https://${host}/api/v1alpha/members?member_type=user`,
  },
});
